export const shareBot = (param: string | number) => {
  const botUsername = 'StarJarTestBot'
  const url = `https://t.me/${botUsername}?startapp=${param}`

  if (navigator.share) {
    navigator
      .share({
        title: 'Share bot',
        url: url,
      })
      .catch((error) => console.log('Error sharing', error))
  }
}
